<nav class="navbar navbar-vertical navbar-expand-md navbar-light bg-white" id="sidenav-main">
  <!-- [ngClass]="{'isVisible': innerWidth >= 765}" -->
  <div class="container-fluid">
    <!-- Toggler -->
    <button class="navbar-toggler" type="button" (click)="isCollapsed=!isCollapsed"
      aria-controls="sidenav-collapse-main">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- Brand -->
    <a class="navbar-brand pt-0" routerLinkActive="active" [routerLink]="['/jobrequest']" *ngIf="isVisible">
      <img src="./assets/img/logo-colored.png" class="navbar-brand-img" alt="..." *ngIf="!isCorporate">
      <img src="./assets/img/corporate.png" class="navbar-brand-img img_holder" alt="..." *ngIf="isCorporate">
    </a>

    <a class="navbar-brand pt-0 text-start" routerLinkActive="active" [routerLink]="['/jobrequest']" *ngIf="!isVisible" >
      <img src="./assets/img/cargaicon.png" class="navbar-brand-img" alt="...">
      <!-- *ngIf="!isCorporate" -->
      <!-- <img src="./assets/img/corporate.png" class="navbar-brand-img img_holder" alt="..." *ngIf="isCorporate && isVisible"> -->
    </a>

   
    <!-- User -->

    <ul class="nav align-items-center d-md-none">
      <!-- <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link nav-link-icon" role="button" ngbDropdownToggle>
          <i class="ni ni-bell-55"></i>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <a class="dropdown-item" href="javascript:void(0)">Action</a>
          <a class="dropdown-item" href="javascript:void(0)">Another action</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
        </div>
      </li>
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="./assets/img/theme/team-1-800x800.jpg">
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <div class=" dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </div>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#!" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>
        </div>
      </li> -->
    </ul>

    <!-- Collapse -->
    <div class="collapse navbar-collapse" [ngbCollapse]="isCollapsed" id="sidenav-collapse-main" *ngIf="isVisible">
      <!-- Collapse header -->
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a routerLinkActive="active" [routerLink]="['/dashboard']">
              <img src="./assets/img/logo-colored.png">
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button type="button" class="navbar-toggler" (click)="isCollapsed=!isCollapsed">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <!-- Form -->
      <form class="mt-4 mb-3 d-md-none">
        <div class="input-group input-group-rounded input-group-merge">
          <input type="search" class="form-control form-control-rounded form-control-prepended" placeholder="Search"
            aria-label="Search">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <span class="fa fa-search"></span>
            </div>
          </div>
        </div>
      </form>
      <!-- Navigation -->


      <!-- <ul class="navbar-nav mb-md-3" *ngIf="innerWidth >= 765">
        <li class="nav-item">
          <a class="nav-link" (click)="openMenu()">
            <div class="icon_holder">
              <img src="../../../assets/icon/menu-close.png">
            </div>
          </a>
        </li>
      </ul> -->

      <ul class="navbar-nav">
        <li *ngFor="let menuItem of menuItems"
          class="{{menuItem.class}} nav-item d-flex justify-content-start align-items-center"
          (click)="updateNotif(menuItem)">
          <!-- <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link" *ngIf="menuItem.path === '/transactions'">
            <div class="icon_holder">
                <span class="badge_transaction badge badge-light"
                *ngIf="menuItem.path === '/transactions' && (inprogCount !== 0 && pendingCount !== 0)">{{ (pendingCount + inprogCount) }}</span>
              <img src="{{menuItem.icon}}">
            </div>
            {{menuItem.title}}
          </a> -->
          <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link">
            <div class="icon_holder">
              <!-- <span class="badge_custom badge badge-light"
                *ngIf="menuItem.path === '/notification' && countsNotif !== 0 ">{{ countsNotif }}</span> -->
              <img src="{{menuItem.icon}}">
            </div>
            {{menuItem.title}}
          </a>
          <span class="custom_font badge badge-primary badge-pill animate__animated animate__pulse animate__delay-2s"
            *ngIf="menuItem.path === '/transactions' && (inprogCount !== 0 && pendingCount !== 0) ">{{ (pendingCount +
            inprogCount) }}</span>
          <span class="custom_font badge badge-danger badge-pill animate__animated animate__pulse animate__delay-2s"
            *ngIf="menuItem.path === '/notification' && countsNotif !== 0 ">{{ countsNotif }}</span>
        </li>
      </ul>
      <!-- Divider -->
      <hr class="my-3">
      <!-- Heading -->
      <!-- <h6 class="navbar-heading text-muted">About us</h6> -->
      <!-- Navigation -->
      <ul class="navbar-nav mb-md-3">
        <li class="nav-item">
          <a class="nav-link" (click)="logout()">
            <div class="icon_holder">
              <img src="../../../assets/icon/home/logout.svg">
            </div> Logout
          </a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link">
           <small>Version {{ appVersion }}</small>
          </a>
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" href="https://www.ecarga.com.ph/about.html" [routerLink]="['/services']">
            <i class="ni ni-books" color="primary"></i> Services
          </a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" href="https://www.youtube.com/playlist?list=PLqefIo0v_YB7KemtiO7vcS9W22zdaEgMM"
            target="_blank">
            <div class="icon_holder_youtube">
              <img src="../../../assets/icon/home/youtube.svg">
            </div> How to book?
          </a>
        </li>
      </ul>
    </div>

    <!-- Hidden -->
    <div class="collapse navbar-collapse isVisibleCollapse"  [ngbCollapse]="!isCollapsed" id="sidenav-collapse-main" *ngIf="!isVisible">
      <!-- Collapse header -->
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a routerLinkActive="active" [routerLink]="['/dashboard']">
              <img src="./assets/img/logo-colored.png">
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button type="button" class="navbar-toggler" (click)="isCollapsed=!isCollapsed">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <!-- Form -->
      <form class="mt-4 mb-3 d-md-none">
        <div class="input-group input-group-rounded input-group-merge">
          <input type="search" class="form-control form-control-rounded form-control-prepended" placeholder="Search"
            aria-label="Search">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <span class="fa fa-search"></span>
            </div>
          </div>
        </div>
      </form>
      <!-- Navigation -->

      <ul class="navbar-nav mb-md-3" *ngIf="innerWidth >= 765">
        <li class="nav-item">
          <a class="nav-link" (click)="openMenu()">
            <div class="icon_holder">
              <img src="../../../assets/icon/menu.png">
            </div>
          </a>
        </li>
      </ul>

      <ul class="navbar-nav">
        <li *ngFor="let menuItem of menuItems"
          class="{{menuItem.class}} nav-item d-flex justify-content-start align-items-center"
          (click)="updateNotif(menuItem)">
          <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link">
            <div class="icon_holder">
              <img src="{{menuItem.icon}}">
            </div>
            <span *ngIf="innerWidth < 765">{{menuItem.title}}</span>
          </a>
        </li>
      </ul>
      <!-- Divider -->
      <hr class="my-3">
      <!-- Heading -->
      <!-- <h6 class="navbar-heading text-muted">About us</h6> -->
      <!-- Navigation -->
      <ul class="navbar-nav mb-md-3">
        <li class="nav-item">
          <a class="nav-link" (click)="logout()">
            <div class="icon_holder">
              <img src="../../../assets/icon/home/logout.svg">
            </div>
            <span *ngIf="innerWidth < 765">Logout</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.youtube.com/playlist?list=PLqefIo0v_YB7KemtiO7vcS9W22zdaEgMM"
            target="_blank">
            <div class="icon_holder_youtube">
              <img src="../../../assets/icon/home/youtube.svg">
            </div>
            <span *ngIf="innerWidth < 765">How to book?</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- To open in app -->
    <!-- <div class="row d-flex">
      <a class="nav-link" (click)="launchAppOnAndroidDevice()">
        <small>use app</small>
      </a>
    </div> -->

    <!-- Version -->
    <div class="row d-flex" *ngIf="isVisible">
      <a class="nav-link">
        <small>Version {{ appVersion }}</small>
      </a>
    </div>
  </div>
</nav>